import { Icon, Text, HStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { useNavigation } from '@react-navigation/native';
import { View } from 'native-base';
import { Pressable } from 'react-native';

import { SignedInNavigationScreenNavigationProp } from '../../routes/types';
import { ValueDisplayToggle } from '../Home/components/Header/components/ValueDisplayToggle';
import { Top15Products } from '../Home/components/Top15Products';

export const HomeTop15Products = () => {
  const navigation = useNavigation<SignedInNavigationScreenNavigationProp>();

  const handleGoBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      navigation.navigate('Home');
    }
  };

  return (
    <View flex={1} width="100%" minWidth="100%" backgroundColor={Color['neutral.white']}>
      <HStack
        paddingX={Spacing['stack.xxxs']}
        paddingY={[Spacing['inline.xxxs']]}
        direction="row"
        justifyContent="space-between">
        <HStack space={Spacing['stack.nano']} alignItems="center">
          <Pressable onPress={handleGoBack}>
            <Icon testId="testID" name="ArrowLeft" color={Color['neutral.dark']} size="xxs" />
          </Pressable>
          <Text variant="bold" fontSize={Typography['fontsize.lg']}>
            Top 15 Produtos
          </Text>
        </HStack>
        <ValueDisplayToggle isMobile color={Color['neutral.black']} />
      </HStack>
      <Top15Products isMobile />
    </View>
  );
};
